import * as Sentry from "@sentry/react";

function isAnonymousException(exception?: Sentry.Exception): boolean {
  return exception?.stacktrace?.frames?.[0].filename === "<anonymous>";
}

function isFilePlayerException(exception?: Sentry.Exception): boolean {
  return exception?.stacktrace?.frames?.[0].filename?.includes("FilePlayer.js") ?? false;
}

function isHlsException(exception?: Sentry.Exception): boolean {
  return exception?.stacktrace?.frames?.some(frame => frame.filename?.includes("hls.js")) ?? false;
}

function isNetworkError(exception?: Sentry.Exception): boolean {
  return (
    exception?.type === "AxiosError" && exception?.value?.toLocaleLowerCase() === "network error"
  );
}

function isRequestAbortedError(exception?: Sentry.Exception): boolean {
  return (
    exception?.type === "AxiosError" && exception?.value?.toLocaleLowerCase() === "request aborted"
  );
}

function isTimeoutExceededError(exception?: Sentry.Exception): boolean {
  return (
    exception?.type === "AxiosError" && exception?.value?.toLocaleLowerCase() === "timeout exceeded"
  );
}

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
  release: import.meta.env.VITE_SENTRY_RELEASE,
  dist: import.meta.env.VITE_SENTRY_DIST,
  allowUrls: [/https?:\/\/(beta\.)?tradefoox\.com/],
  beforeSend: (event: Sentry.ErrorEvent) => {
    const exception = event.exception?.values?.[0];
    if (
      isAnonymousException(exception) ||
      isFilePlayerException(exception) ||
      isHlsException(exception) ||
      isNetworkError(exception) ||
      isRequestAbortedError(exception) ||
      isTimeoutExceededError(exception)
    ) {
      return null;
    }
    return event;
  },
});
